/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NFSPermission
 */
export interface NFSPermission {
    /**
     * 
     * @type {string}
     * @memberof NFSPermission
     */
    host: string;
    /**
     * 
     * @type {boolean}
     * @memberof NFSPermission
     */
    readOnly: boolean;
    /**
     * 
     * @type {string}
     * @memberof NFSPermission
     */
    options: string;
}

export function NFSPermissionFromJSON(json: any): NFSPermission {
    return NFSPermissionFromJSONTyped(json, false);
}

export function NFSPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): NFSPermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'host': json['host'],
        'readOnly': json['read_only'],
        'options': json['options'],
    };
}

export function NFSPermissionToJSON(value?: NFSPermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'host': value.host,
        'read_only': value.readOnly,
        'options': value.options,
    };
}


